export default {
      id: "mission-check-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#mission-check",
      toString: function () {
        return this.url;
      }
    }